<template>
  <div class="header-options">
    <button v-if="loginButton" class="button button-contrast" type="button" @click.stop="toggleLogin" :class="{'is-logged-in': isLoggedIn}" :title="(!isLoggedIn ? loginData.header : loginData.logoutHeader)">
      <svg class="svg-fill-stroke">
        <use xlink:href="#loginSvg"></use>
      </svg>
    </button>
    <button type="button" class="button-font" :title="buttonData.fontDown" @click.stop="decrementFontSize" :disabled="fontSize === fontSizeMin">
      A<sup>-</sup>
    </button>
    <button type="button" class="button-font" :title="buttonData.fontUp" @click.stop="incrementFontSize" :disabled="fontSize === fontSizeMax">
      A<sup>+</sup>
    </button>
    <button class="button button-contrast"  type="button" @click.stop="toggleContrast" :title="buttonData.contrastMode">
      <svg>
        <use xlink:href="#contrastSvg"></use>
      </svg>
    </button>
    <button class="button button-contrast" :class="{'active': inClipboard}" type="button" v-if="clipboard" @click.stop="clipboardActions" :title="(inClipboard ? buttonData.clipboardRemove : buttonData.clipboardAdd)">
      <svg>
        <use xlink:href="#iconClipboard"></use>
      </svg>
    </button>
    <div class="custom-select" @click.stop="customSelectOpen = !customSelectOpen" :class="{'open': customSelectOpen}">
      <button type="button" :title="buttonData.language">
        {{selectedTranslation}}
        <svg v-if="customSelectOpen">
          <use xlink:href="#arrowUpSvg"></use>
        </svg>
        <svg v-else>
          <use xlink:href="#arrowDownSvg"></use>
        </svg>
      </button>
      <ul class="options" v-if="customSelectOpen">
        <li v-for="item in translations" :key="item" @click.stop="selectTranslation(item)">
          {{item}}
        </li>
      </ul>
    </div>
    <button type="button" v-if="!isMobile && !iframeFullscreen" @click.stop="toggleFullscreen" :title="(isFullscreen ? buttonData.fullscreenClose : buttonData.fullscreenOpen)">
      <svg>
        <use v-if="isFullscreen" xlink:href="#iconFullScreenClose"></use>
        <use v-else xlink:href="#iconFullScreenOpen"></use>
      </svg>
    </button>
    <button type="button" v-if="tiles" class="tiles" @click.stop="togglePageNav" :title="buttonData.categoriesAll">
      <svg v-if="pageNavOpen">
        <use xlink:href="#tilesCloseSvg"></use>
      </svg>
      <svg v-else>
        <use xlink:href="#tilesSvg"></use>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'headerOptions',
  props: ['tiles', 'loginButton', 'clipboard'],
  data: function () {
    return {
      customSelectOpen: false,
      ticking: false
    }
  },
  methods: {
    ...mapActions([
      'incrementFontSize',
      'decrementFontSize',
      'clipboardActions',
      'toggleContrast',
      'togglePageNav',
      'toggleLogin',
      'toggleFullscreen'
    ]),
    selectTranslation (lang) {
      this.$store.state.mainData.settings.selectedTranslation = lang
      this.customSelectOpen = false
    }
  },
  computed: {
    ...mapGetters([
      'availableTranslations',
      'breakpoint',
      'buttonData',
      'contrast',
      'fontSize',
      'fontSizeMax',
      'fontSizeMin',
      'inClipboard',
      'isLoggedIn',
      'isFullscreen',
      'iframeFullscreen',
      'loginData',
      'pageNavOpen',
      'selectedTranslation'
    ]),
    translations () {
      return this.availableTranslations.filter(el => el !== this.selectedTranslation)
    },
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  }
}
</script>

<style scoped lang="scss">
  .header-options {
    display: flex;
  }

  button {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    align-content: center;
    align-items: center;
    cursor: pointer;
    color: $text-dark;
    border: none;
    vertical-align: middle;
    user-select: none;
    font-weight: 600;
    font-size: $font-s;
    margin: 0;
    padding: 1px 6px;
    &:hover {
      @include biger-then-tablet {
        transform: scale(1.2);
        color: $text-accent;

        svg:not(.svg-fill-stroke) {
          fill: $text-accent;
        }
      }
    }
    svg {
      max-width: 100%;
      max-height: 100%;
      height: 14px;
      margin: auto;
      width: 14px;
    }
    &:focus {
      outline: none;
    }
    &:disabled {
      cursor: auto;
      opacity: 0.4;
      color: inherit;
    }
    .dark & {
      color: $text-light;
      &:hover {
        @include biger-then-tablet {
          color: $text-accent;
        }
        &:disabled {
          color: inherit;
        }
      }
    }
  }
  .button-font {
    height: 30px;
    padding: 1px 12px 1px 4px;
    position: relative;

    sup {
      font-size: 1em;
      line-height: 1em;
      position: absolute;
      right: 4px;
      top: 5px;
    }

  }
  .custom-select {
    text-transform: uppercase;
    vertical-align: middle;
    display: inline-block;
    position: relative;
    min-width: 30px;
    margin: 0 6px;
    button {
      text-transform: uppercase;
      padding: 6px;
      margin: 0;
      svg {
        height: 10px;
        width: 10px;
        margin-left: 6px;
      }
    }
    .options {
      background: $body-bg;
      position: absolute;
      top: 100%;
      left: 0;
      list-style: none;
      margin: 0;
      padding: 4px 0;
      min-width: 100%;

      .dark & {
        background: rgba($bg-dark, 0.8);
      }

      .hight-contrast & {
        background: $contrast-bg;
        border-bottom: 3px solid $contrast-accent;
      }

      li {
        font: {
          size: $font-s;
          weight: 600;
        }
        text: {
          align: left;
          transform: uppercase;
        }
        margin: 5px 0;
        padding: 0 6px;
        cursor: pointer;
      }
    } // END .options;

    &.open {
      .options {
        .mobile-bottom-menu & {
          bottom: 100%;
          top: auto;

          .hight-contrast & {
            border-top: 3px solid $contrast-accent;
            border-bottom: 0 none;
          }
        }
      }
    } // END .custom-select.open;

  } // END .custom-select;
  .button-contrast {
    width: 30px;
    height: 30px;
    padding: 1px 4px;

    svg {
      height: 12px;
      width: 12px;
    }

    &.active {
      color: $text-accent;
      svg { fill: $text-accent; }

      .dark & {
        color: $color-inverted;
        svg { fill: $color-inverted; }
      }
    }
  }
  .tiles {
    height: 30px;
    left: 50%;
    margin: 0 0 0 -15px;
    position: absolute;
    top: 0;
    width: 30px;
  }
</style>
